import React from "react";

const ServiceCard = ({ image, title, description }) => (
  <div
    className="relative rounded-xl overflow-hidden shadow-lg group w-full h-full"
    style={{
      minHeight: "320px",
      maxHeight: "380px",
      height: "100%",
    }}
  >
    <img src={image} alt={title} className="w-full h-full object-cover" />
    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 py-4 pl-6 pr-8 text-left">
      <div
        className="h-[50px] flex items-center"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <h3
          className="text-white !font-montserrat font-bold !text-lg leading-tight w-full"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "flex",
            alignItems: "center",
            maxHeight: "48px",
          }}
        >
          {title}
        </h3>
      </div>
    </div>
  </div>
);

export default ServiceCard;
